const MC_ASSISTANT = 'mc-assistant';
const APP_HEADER = 'global-header';
const NUNI_HEADER = 'nuni-header';
const IN_APP_OVERLAY = 'in-app-help-overlay';
const MC_APPOINTMENT = 'mc-appointment';
const SMS_SIGN_UP = 'sms-sign-up';
const CAMPAIGN_MANAGER_CREATE = 'campaign-manager-create';
const CR2_FULLSCREEN_TAKEOVER = 'cr2-fullscreen-takeover';
const CR2_SHOPIFY_INTEGRATION = 'cr2-shopify-integration';
const CR2_WOOCOMMERCE_INTEGRATION = 'cr2-woocommerce-integration';
const CR2_CUSTOMER_JOURNEY_BUILDER = 'cr2-customer-journey-builder';
const CR2_KLAVIYO_API = 'cr2-klaviyo-api';
const SCALED_CSM_EMAIL = 'scaled-csm-email';
const PAUSE_CANCEL_MAIN_BANNER = 'pause-cancel-main-banner';
const PAUSE_MODAL_CTA = 'pause-modal-cta';
const PRS_SURVEY = 'prs-survey';
const PRODUCT_SUPPORT_ACCOUNT_SETUP_CHECKLIST_COMPLETE =
  'product-support-account-setup-checklist-complete';
const DELETE_MAIN_BANNER = 'delete-main-banner';
const DELETE_TOO_EXPENSIVE_CTA = 'delete-too-expensive-cta';
const PRICE_CHANGE_DEEP_LINK = 'price-change-deeplink';
const SCALED_ONBOARDING_EMAIL = 'scaled-onboarding-email';
const SCALED_ONBOARDING_FOLLOWUP_EMAIL = 'scaled-onboarding-follow-up-email';
const SCALED_ONBOARDING_PT_EMAIL = 'scaled-onboarding-pt-email';
const SCALED_ONBOARDING_ES_EMAIL = 'scaled-onboarding-es-email';
const SCALED_ONBOARDING_OVERLAYIPD = 'scaled-onboarding-overlayIPD';
const SCALED_ONBOARDING_IPDRECS = 'scaled-onboarding-IPDRecs';
const SCALED_ONBOARDING_RESCHEDULE = 'scaled-onboarding-reschedule';
const SCALED_ONBOARDING_SALES = 'scaled-onboarding-sales';
const SCALED_ONBOARDING_IPDCM = 'scaled-onboarding-IPDCM';
const SCALED_ONBOARDING_INPRODUCT = 'scaled-onboarding-InProduct';
const SCALED_ONBOARDING_PERSISTENT_PATH = 'scaled-onboarding-persistent-path';
const SCALED_ONBOARDING_DEEPLINK = 'scaled-onboarding-deeplink';
const SCALED_ONBOARDING_ACCOUNT_SETUP = 'scaled-onboarding-account-setup';
const SCALED_ONBOARDING_CHECKOUT_CONFIRMATION =
  'scaled-onboarding-checkout-confirmation';
const SCALED_ONBOARDING_PRODUCT_SUPPORT = 'scaled-onboarding-productsupport';
const SCALED_ONBOARDING_ACCOUNT_MANAGEMENT =
  'scaled-onboarding-accountmanagement';
const SCALED_ONBOARDING_STRATEGIC_ONBOARDING =
  'scaled-onboarding-strategiconboarding';
const SCALED_ONBOARDING_GTKM = 'scaled-onboarding-GTKM';
const SCALED_ONBOARDING_ACCOUNT_SETUP_CHECKLIST =
  'scaled-onboarding-account-setup-checklist';
const SCALED_AM_EMAIL_RR_SMS_SWITCHER_PILOT =
  'scaled-am-email-rr-sms-switcher-pilot';
const SCALED_AM_EMAIL_DQ1_SMS_SWITCHER_PILOT =
  'scaled-am-email-dq1-sms-switcher-pilot';
const SCALED_AM_EMAIL_DQ2_SMS_SWITCHER_PILOT =
  'scaled-am-email-dq2-sms-switcher-pilot';
const SCALED_AM_EMAIL_DQ3_SMS_SWITCHER_PILOT =
  'scaled-am-email-dq3-sms-switcher-pilot';
const SCALED_AM_EMAIL_DQ4_SMS_SWITCHER_PILOT =
  'scaled-am-email-dq4-sms-switcher-pilot';
const SCALED_AM_IPC_RR_SMS_INITIAL_ADOPTION =
  'scaled-am-ipc-rr-sms-initial-adoption';
const SCALED_CSM_LEFTNAV = 'scaled-csm-leftnav';
const STRATEGIC_ONBOARDING_CHILIPIPER_LINK =
  'https://mailchimp.na.chilipiper.com/router/onboarding-kickoff-country?utm_source=revr&utm_campaign=persistent';
const STRATEGIC_ONBOARDING_CHILIPIPER_SCHEDULED_APPOINTMENT_LINK =
  'https://mailchimp.na.chilipiper.com/router/onboarding-kickoff';
const STRATEGIC_ONBOARDING_INTUIT_CHILIPIPER_LINK =
  'https://intuitsales.chilipiper.com/concierge-router/link/onboarding-kickoff';
const SCALED_ONBOARDING_WOOCOMM = 'scaled-onboarding-woocomm';
const MC_OOP = 'mc-oop';
const POPUP_FORMS_ADD_ON = 'popup-forms-add-on';
const INTUIT_ASSIST_CONTACT_US = MC_ASSISTANT;

export {
  MC_ASSISTANT,
  APP_HEADER,
  NUNI_HEADER,
  IN_APP_OVERLAY,
  MC_APPOINTMENT,
  SMS_SIGN_UP,
  CAMPAIGN_MANAGER_CREATE,
  CR2_FULLSCREEN_TAKEOVER,
  CR2_SHOPIFY_INTEGRATION,
  CR2_WOOCOMMERCE_INTEGRATION,
  CR2_CUSTOMER_JOURNEY_BUILDER,
  CR2_KLAVIYO_API,
  SCALED_CSM_EMAIL,
  PAUSE_CANCEL_MAIN_BANNER,
  PAUSE_MODAL_CTA,
  PRS_SURVEY,
  DELETE_MAIN_BANNER,
  DELETE_TOO_EXPENSIVE_CTA,
  PRICE_CHANGE_DEEP_LINK,
  PRODUCT_SUPPORT_ACCOUNT_SETUP_CHECKLIST_COMPLETE,
  SCALED_ONBOARDING_EMAIL,
  SCALED_ONBOARDING_FOLLOWUP_EMAIL,
  SCALED_ONBOARDING_PT_EMAIL,
  SCALED_ONBOARDING_ES_EMAIL,
  SCALED_ONBOARDING_OVERLAYIPD,
  SCALED_ONBOARDING_IPDRECS,
  SCALED_ONBOARDING_RESCHEDULE,
  SCALED_ONBOARDING_SALES,
  SCALED_ONBOARDING_IPDCM,
  SCALED_ONBOARDING_INPRODUCT,
  SCALED_ONBOARDING_PERSISTENT_PATH,
  SCALED_ONBOARDING_DEEPLINK,
  SCALED_ONBOARDING_ACCOUNT_SETUP,
  SCALED_ONBOARDING_CHECKOUT_CONFIRMATION,
  SCALED_ONBOARDING_PRODUCT_SUPPORT,
  SCALED_ONBOARDING_ACCOUNT_MANAGEMENT,
  SCALED_ONBOARDING_STRATEGIC_ONBOARDING,
  SCALED_ONBOARDING_GTKM,
  SCALED_ONBOARDING_WOOCOMM,
  SCALED_ONBOARDING_ACCOUNT_SETUP_CHECKLIST,
  SCALED_AM_EMAIL_RR_SMS_SWITCHER_PILOT,
  SCALED_AM_EMAIL_DQ1_SMS_SWITCHER_PILOT,
  SCALED_AM_EMAIL_DQ2_SMS_SWITCHER_PILOT,
  SCALED_AM_EMAIL_DQ3_SMS_SWITCHER_PILOT,
  SCALED_AM_EMAIL_DQ4_SMS_SWITCHER_PILOT,
  SCALED_AM_IPC_RR_SMS_INITIAL_ADOPTION,
  SCALED_CSM_LEFTNAV,
  STRATEGIC_ONBOARDING_CHILIPIPER_LINK,
  STRATEGIC_ONBOARDING_CHILIPIPER_SCHEDULED_APPOINTMENT_LINK,
  STRATEGIC_ONBOARDING_INTUIT_CHILIPIPER_LINK,
  MC_OOP,
  POPUP_FORMS_ADD_ON,
  INTUIT_ASSIST_CONTACT_US,
};
